import { Component, OnInit, Inject, ViewChild, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OldDataService } from 'src/app/core/services/old-data.service';

import { getFirebaseBackend } from 'src/app/authUtils';
import { CalendarOptions, EventClickArg, EventApi, EventInput } from '@fullcalendar/angular';
// BootStrap
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import Swal from 'sweetalert2';
import { Campaign } from '../../../core/models/campaign';
import { ContractsService } from '../../../services/contracts/contracts.service';
import { ContractsCampaigns } from '../../../core/models/client';
import { Subject } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { category, calendarEvents, createEventId } from './data-calendar';
import { User } from '../../../core/models/user';

import { CampaignInfo } from '../../../core/models/campaign_info';
import { CampaignCriteriaComponent } from './components/campaign-criteria/campaign-criteria.component';
import { SideMenuComponent } from './components/side-menu/side-menu.component';
import { OrdersService } from '../../../services/orders/orders.service';

import { DomSanitizer } from '@angular/platform-browser';
import { CampaignService } from '../../../services/campaigns/campaign.service';
import * as dayjs from 'dayjs';
import { CalendarService } from 'src/app/services/calendar/calendar.service';
import { MONTHS, DAYS, YEARS, CAMPAIGN_EDIT_MENU, APPT_TYPES, INDUSTRIES, TIME_ZONES } from 'src/app/shared/constants';
import { UserService } from 'src/app/services/user/user.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { ToastService } from 'src/app/pages/dashboards/dashboard/toast-service';
declare var createGoogleEvent: any;

@Component({
	selector: 'app-campaign-edit',
	templateUrl: './campaign-edit.component.html',
	styleUrls: ['./campaign-edit.component.scss'],
})
export class CampaignEditComponent implements OnInit {
	@ViewChild('criteria') criteria: CampaignCriteriaComponent;
	@ViewChild('sideMenu') sideMenu: SideMenuComponent;
	// Calendar Variables
	// public view: CalendarView = CalendarView.Month;
	// public events: CalendarEvent[] = [];
	public refresh: Subject<any> = new Subject();

	// public CalendarView = CalendarView;
	public viewDate: Date = new Date();
	// Terminan variables del calendario
	// Constants
	public typeArray: any[];
	public timezones: any[];
	public industries: any[];
	public types: any[];

	public user: User;
	public campaign: Campaign;
	public campaignInfo: CampaignInfo;

	public formBasicInfo: FormGroup;
	public formCriteria: FormGroup;
	public formCampaignInfo: FormGroup;

	public campaignId: number;
	public campaignMsg: string;
	public campaignLoading: boolean = true;

	// Navigation Vars
	public sideMenuOptions: any[];
	public activeTab: string = 'basic';
	public callSheetTab: string = 'bio';

	public dispoLog: any;
	public dispoLogLoading: boolean = false;
	public dispoSearchMonth: number;
	public dispoSearchDay: number;
	public dispoSearchYear: number;

	public recordsCount: number = 0;
	public recordsLoading: boolean = false;

	public dispoCount: number = 0;
	public leadfCount: number = 0;
	public leadpCount: number = 0;
	public leadZoomCount: number = 0;
	public loadingStats: boolean = false;

	public usersSelect: any[] = [];

	public remaining: number;
	public order: any;

	// Contract Vars
	public allcontracts = [];
	public campaignsClient: ContractsCampaigns = {
		idContractsCampaigs: 0,
		contractid: 0,
		alias: '',
		campaignid: 0,
		userid: 0,
		contractid_ini: 0,
	};

	// calendar
	eventos!: any[];
	calendarEvents!: any[];
	editEvent: any;
	formEditData!: FormGroup;
	newEventDate: any;
	category!: any[];
	submitted = false;
	datos: any; // Variable para almacenar los datos recibidos

	public textoEnriquecido;
	public selectedFieldToEdit;
	public bioData = {
		script: null,
		who_we_are: null,
		what_we_do: null,
		why_us: null,
		email_template: null,
	};

	public months = MONTHS;
	public days = DAYS;
	public years = YEARS;

	public email_template = {
		from: 'qc@lmsleads.com',
		to: '',
		cc: '',
		bcc: '',
		body: '',
		subject: '',
	};

	public addedHours = 0;

	// Calendar click Event
	formData!: FormGroup;
	@ViewChild('editmodalShow') editmodalShow!: TemplateRef<any>;
	@ViewChild('modalShow') modalShow!: TemplateRef<any>;
	@ViewChild('textEditor') textEditorModal!: TemplateRef<any>;
	appointmentForm!: FormGroup;
	calendarData: any;

	constructor( public toastSrv: ToastService, private router: Router, private dataService: OldDataService, private route: ActivatedRoute, private userSrv: UserService, private contractSrv: ContractsService, private campaignSrv: CampaignService, public toastService: ToastService, private ordersService: OrdersService, private modalService: NgbModal, private formBuilder: FormBuilder, private calendarService: CalendarService, private fb: FormBuilder, private sanitizer: DomSanitizer, private utils: UtilsService) {
		this.user = getFirebaseBackend()?.getAuthenticatedUser();
		this.sideMenuOptions = CAMPAIGN_EDIT_MENU;
		this.types = APPT_TYPES;
		this.industries = INDUSTRIES;
		this.typeArray = APPT_TYPES;
		this.timezones = TIME_ZONES;
		this.activeTab = 'basic';

		// if (this.user.isAdmin == 1) {
		if (this.route.snapshot.queryParams['id']) {
			this.campaignId = this.route.snapshot.queryParams['id'];

			let d = new Date();
			let month = d.getMonth() + 1;
			let day = new Date().getDate();
			let year = d.getFullYear();

			this.dispoSearchMonth = this.pad(month, 2, 0);
			this.dispoSearchDay = this.pad(day, 2, 0);
			this.dispoSearchYear = year;
		}
		// } else {
		//     // this.authenticationService.logout('-------------------Constructor Campaign edit');
		//     // location.reload();
		// }

		this.formBasicInfo = new FormGroup({
			name: new FormControl('', Validators.required),
			alias: new FormControl(''),
			contract: new FormControl(''),
			campaign_type: new FormControl('D'),
			prospects_type: new FormControl('B2B'),
			callback_no: new FormControl('', [Validators.maxLength(10)]),
			timezone: new FormControl(''),
			points: new FormControl(''),
			industry: new FormControl(''),
			source: new FormControl(''),
			lead_cost: new FormControl(''),
			appts_month: new FormControl(''),
			hourly_start_date: new FormControl(''),
			budget_hours: new FormControl(''),
			total_worked_time: new FormControl(''),
			week_1: new FormControl('0'),
			week_2: new FormControl('0'),
			week_3: new FormControl('0'),
			week_4: new FormControl('0'),
			billing_notes: new FormControl(''),
			campaign_notes: new FormControl(''),
			user_id: new FormControl('')
		});

		this.formCampaignInfo = new FormGroup({
			campaign: new FormControl(''),
			address_1: new FormControl(''),
			address_2: new FormControl(''),
			city: new FormControl(''),
			state: new FormControl(''),
			zip: new FormControl(''),
			website_url: new FormControl(''),
			notes: new FormControl(''),
			questions: new FormControl(''),
			who_we_are: new FormControl(''),
			what_we_do: new FormControl(''),
			why_us: new FormControl(''),
			email_template: new FormControl(''),
			script: new FormControl(''),
			attending: new FormControl(''),
			scheduling: new FormControl(''),
			additional_calendar_url: new FormControl(''),
		});
	}

	ngOnInit(): void {
		this.getCampaignById();
		this.getCampaignInfo();
		this.getClientUsers();

		// this.getHourlyCampaignInfo();
		// this.toastService.clear();

		// Validation
		this.formData = this.formBuilder.group({
			title: ['', [Validators.required]],
			category: ['', [Validators.required]],
		});
		this._fetchData();

		this.appointmentForm = this.fb.group({
			appointmentTime: ['', Validators.required],
			endAppointmentTime: ['', Validators.required],
			titleEvent: '',
		});
	}

	/**
	 * Fetches the data
	 */
	private _fetchData() {
		// Event category
		this.category = category;

		// Calender Event Data
		this.calendarEvents = calendarEvents;
	}

	pad(n, width, z) {
		z = z || '0';
		n = n + '';
		return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
	}

	getCampaignById() {
		this.campaignSrv.getCampaignAndInfoById(this.campaignId).subscribe((data) => {
			if (data) {
				this.campaign = data.body;
				this.formBasicInfo.get('name').setValue(this.campaign.name);
				this.formBasicInfo.get('alias').setValue(this.campaign.alias);
				this.formBasicInfo.get('contract').setValue(this.campaign.contractid);
				this.formBasicInfo.get('campaign_type').setValue(this.campaign.campaign_type);
				this.formBasicInfo.get('prospects_type').setValue(this.campaign.prospects_type);
				this.formBasicInfo.get('callback_no').setValue(this.campaign.callback_no);
				this.formBasicInfo.get('timezone').setValue(this.campaign.timezone);
				this.formBasicInfo.get('points').setValue(this.campaign.points);
				this.formBasicInfo.get('industry').setValue(this.campaign.industry);
				this.formBasicInfo.get('source').setValue(this.campaign.source);
				this.formBasicInfo.get('appts_month').setValue(this.campaign.appts_month);
				this.formBasicInfo.get('week_1').setValue(this.campaign.week_1);
				this.formBasicInfo.get('week_2').setValue(this.campaign.week_2);
				this.formBasicInfo.get('week_3').setValue(this.campaign.week_3);
				this.formBasicInfo.get('week_4').setValue(this.campaign.week_4);
				this.formBasicInfo.get('billing_notes').setValue(this.campaign.billing_notes);
				this.formBasicInfo.get('campaign_notes').setValue(this.campaign.campaign_notes);
				this.formBasicInfo.get('hourly_start_date').setValue(this.campaign.hourly_start_date);

				this.email_template.subject = this.campaign.subject_email ? this.campaign.subject_email : '';

				this.formCampaignInfo.get('email_template').setValue(this.campaign.email_template);
				this.bioData.email_template = this.sanitizer.bypassSecurityTrustHtml(this.campaign.email_template);

				this.campaignsClient.contractid_ini = this.campaign.contractid;
				if (this.campaign.types != null && this.campaign.types != '') {
					this.campaign.types = this.campaign.types.split(',');
				} else {
					this.campaign.types = [];
				}

				this.campaign.metadata = {};

				this.getDispoCount();

				this.ordersService.getDataOrderByCampaign(this.campaign.id).subscribe((res: any) => {
					if (res.body.length >= 1) {
						this.order = res.body[0];
						if (this.order.type_orderid == 1) {
							this.getRemainingLeads(this.campaign.id);
						} else if (this.order.type_orderid == 3) {
							this.getRemainingHours(this.campaign.id, this.order.start_date, this.order.total_hours);
						}
					}
				});
			} else {
				this.campaignMsg = 'FAIL: This campaign is not available.';
			}
			this.campaignLoading = false;
		});
	}

	getRemainingLeads(id) {
		this.ordersService.getRemainingLeads(id).subscribe((data: any) => {
			if (!data.hasOwnProperty('error')) {
				if (data.body.records.length > 0) {
					this.remaining = parseInt(data.body.records[0].remaining_total);
				}
			}
		});
	}

	getRemainingHours(campaign, start_date, total_hours) {
		this.ordersService.getHoursCampaign(campaign, start_date).subscribe((data: any) => {
			if (data.body.records.length > 0) {
				this.remaining = parseInt(total_hours) - parseFloat(data.body.records[0].sum_time);
			}
		});
	}

	getCampaignInfo() {
		this.campaignSrv.getCampaignInfo(this.campaignId).subscribe((data) => {
			this.campaignInfo = data.body;
			this.formCampaignInfo.get('address_1').setValue(this.campaignInfo.address_1);
			this.formCampaignInfo.get('address_2').setValue(this.campaignInfo.address_2);
			this.formCampaignInfo.get('city').setValue(this.campaignInfo.city);
			this.formCampaignInfo.get('state').setValue(this.campaignInfo.state);
			this.formCampaignInfo.get('zip').setValue(this.campaignInfo.zip);
			this.formCampaignInfo.get('website_url').setValue(this.campaignInfo.website_url);
			this.formCampaignInfo.get('notes').setValue(this.campaignInfo.notes);
			this.formCampaignInfo.get('questions').setValue(this.campaignInfo.questions);
			this.formCampaignInfo.get('who_we_are').setValue(this.campaignInfo.who_we_are);
			this.bioData.who_we_are = this.sanitizer.bypassSecurityTrustHtml(this.campaignInfo.who_we_are);
			this.formCampaignInfo.get('what_we_do').setValue(this.campaignInfo.what_we_do);
			this.bioData.what_we_do = this.sanitizer.bypassSecurityTrustHtml(this.campaignInfo.what_we_do);
			this.formCampaignInfo.get('why_us').setValue(this.campaignInfo.why_us);
			this.bioData.why_us = this.sanitizer.bypassSecurityTrustHtml(this.campaignInfo.why_us);
			this.formCampaignInfo.get('script').setValue(this.campaignInfo.script);
			this.bioData.script = this.sanitizer.bypassSecurityTrustHtml(this.campaignInfo.script);
			this.formCampaignInfo.get('attending').setValue(this.campaignInfo.attending);
			this.formCampaignInfo.get('scheduling').setValue(this.campaignInfo.scheduling);
			this.formCampaignInfo.get('additional_calendar_url').setValue(this.campaignInfo.additional_calendar_url);
		});
	}

	getClientUsers() {
		this.userSrv.getClientUsersSelect().subscribe((data: any) => {
			this.usersSelect = data.body;
		});
	}

	getHourlyCampaignInfo() {
		this.campaignSrv.getCampaignHourlyInfo(this.campaignId).subscribe((data) => {
			const campaignHours = data.body[0];
			this.formBasicInfo.get('budget_hours').setValue(campaignHours.budget_hours);
			this.formBasicInfo.get('total_worked_time').setValue(this.utils.formatSeconds2(campaignHours.total_worked_time));
		});
	}

	// Crear componente de checkboxes
	setTypes(type: number) {
		if (this.campaign.types !== null && this.campaign.types !== '') {
			const index = this.campaign.types.indexOf(type.toString());
			if (index > -1) {
				this.campaign.types.splice(index, 1);
			} else {
				this.campaign.types.push(type.toString());
			}
		} else {
			this.campaign.types.push(type.toString());
		}
	}

	typesContain(type: number) {
		if (this.campaign.types !== null && this.campaign.types !== '') {
			if (this.campaign.types.indexOf(type.toString()) > -1) {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	}

	// Termina componente de Checkboxes
	updateCampaignConfirm() {
		Swal.fire({
			title: 'Update ' + this.formBasicInfo.get('name').value + '?',
			text: 'ARE YOU SURE?',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel',
		}).then((result) => {
			if (result) {
				this.updateCampaign();
				// this.validateForm();
			}
		});
	}

	// TODO: we will deactivate the validation for now...
	validateForm(tab = '') {
		this.activeTab = tab !== '' ? tab : this.activeTab;

		// if (this.formBasicInfo.valid && this.formCampaignInfo) {
		// 	this.updateCampaign();

		// 	if (this.activeTab === 'criteria') {
		// 		this.criteria.saveCriterias();
		// 	}
		// 	this.activeTab = tab !== '' ? tab : this.activeTab;
		// } else {
		// 	this.sideMenu.activeTab = this.activeTab;
		// 	if (this.formBasicInfo.invalid) {
		// 		this.formBasicInfo.markAllAsTouched();
		// 	} else if (this.formCampaignInfo.invalid) {
		// 		this.formBasicInfo.markAllAsTouched();
		// 	}
		// 	Swal.fire(
		// 		'Check your data',
		// 		'Please fill all required items',
		// 		'error',
		// 	);
		// }
	}

	updateCampaign() {
		const campaignForm = this.formBasicInfo.getRawValue();
		this.campaign.name = campaignForm.name;
		this.campaign.alias = campaignForm.alias;
		this.campaign.campaign_type = campaignForm.campaign_type;
		this.campaign.prospects_type = campaignForm.prospects_type;
		this.campaign.callback_no = campaignForm.callback_no;
		this.campaign.timezone = campaignForm.timezone;
		this.campaign.points = campaignForm.points;
		this.campaign.industry = campaignForm.industry;
		this.campaign.source = campaignForm.source;
		this.campaign.lead_cost = campaignForm.lead_cost;
		this.campaign.appts_month = campaignForm.appts_month;
		this.campaign.week_1 = campaignForm.week_1;
		this.campaign.week_2 = campaignForm.week_2;
		this.campaign.week_3 = campaignForm.week_3;
		this.campaign.week_4 = campaignForm.week_4;
		this.campaign.billing_notes = campaignForm.billing_notes;
		this.campaign.campaign_notes = campaignForm.campaign_notes;
		this.campaign.modified_by = this.user.IdUser;

		// Hourly and Reserve Campaigns
		this.campaign.hourly_start_date = campaignForm.hourly_start_date;
		this.campaign.budget_hours = campaignForm.budget_hours;

		// Process campaign types
		if (this.campaign.types !== null && this.campaign.types !== '') {
			this.campaign.types = this.campaign.types.join();
		}
		campaignForm.modified_by = this.user.IdUser;
		campaignForm.types = this.campaign.types;
		campaignForm.campaign_id = this.campaignId;

		// Callsheet info
		campaignForm.script = this.formCampaignInfo.get('script').value;
		campaignForm.who_we_are = this.formCampaignInfo.get('who_we_are').value;
		campaignForm.what_we_do = this.formCampaignInfo.get('what_we_do').value;
		campaignForm.why_us = this.formCampaignInfo.get('why_us').value;
		campaignForm.email_template = this.formCampaignInfo.get('email_template').value;

		campaignForm.address_1 = this.formCampaignInfo.get('address_1').value;
		campaignForm.address_2 = this.formCampaignInfo.get('address_2').value;
		campaignForm.city = this.formCampaignInfo.get('city').value;
		campaignForm.state = this.formCampaignInfo.get('state').value;
		campaignForm.zip = this.formCampaignInfo.get('zip').value;
		campaignForm.website_url = this.formCampaignInfo.get('website_url').value;
		campaignForm.notes = this.formCampaignInfo.get('notes').value;

		campaignForm.questions = this.formCampaignInfo.get('questions').value;
		campaignForm.attending = this.formCampaignInfo.get('attending').value;
		campaignForm.scheduling = this.formCampaignInfo.get('scheduling').value;
		campaignForm.additional_calendar_url = this.formCampaignInfo.get('additional_calendar_url').value;
		campaignForm.user_id = this.formBasicInfo.get('user_id').value;
		campaignForm.id = this.campaignId;

		this.campaignSrv.updateCampaignBasicInfo(campaignForm).subscribe((data) => {
			this.campaign.types = this.campaign.types.split(',');
			this.toastSrv.show('Campaign updated correctly', 'Success');
		});
	}

	isValidURL(str) {
		const regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;

		if (!regex.test(str)) {
			return false;
		} else {
			return true;
		}
	}

	// DISPO LOG PAGE
	getCampaignDispoLogByDate() {
		this.dispoLog = [];

		if (this.dispoSearchYear && this.dispoSearchMonth && this.dispoSearchDay) {
			this.dispoLogLoading = true;

			const date = `${this.dispoSearchYear}-${this.dispoSearchMonth}-${this.dispoSearchDay}`;

			const payload = { campaign: this.campaignId, searchDate: date };

			this.campaignSrv.getCampaignDispoLogByDate(payload).subscribe((data: any) => {
				this.dispoLog = data.body;
				this.dispoLogLoading = false;
			});
		}
	}

	dialProspect(campaign, prospect) {
		this.router.navigate(['/caller/lead-profile'], {
			queryParams: { campaign, prospect },
		});
	}

	// STATS PAGE
	getDispoCount() {
		this.loadingStats = true;

		const leadf = [];
		const leadp = [];
		const zoom = [];
		this.leadfCount = 0;
		this.leadpCount = 0;
		this.leadZoomCount = 0;

		this.campaignSrv.getDisposToCount(this.campaignId).subscribe((data: any) => {
			this.dispoCount = data.body.length;
			for (let dispo of data.body) {
				if (dispo.dispo === 'FACE') {
					leadf.push(dispo);
				}
				if (dispo.dispo === 'PHONE') {
					leadp.push(dispo);
				}
				if (dispo.dispo === 'ZOOM') {
					zoom.push(dispo);
				}
			}

			this.leadfCount = leadf.length;
			this.leadpCount = leadp.length;
			this.leadZoomCount = zoom.length;
			this.loadingStats = false;
		});
	}

	getAllContracts() {
		if (this.campaignId > 0) {
			this.contractSrv.getAllContracts().subscribe((data: any) => {
				if (!data.hasOwnProperty('error')) {
					if (data.body.length > 0) {
						this.allcontracts = data.body;
					} else {
						this.allcontracts = [];
					}
				} else {
					this.allcontracts = [];
				}
			});
		}
	}

	// // Calendar Functions
	// handleEvent(action: string, event: CalendarEvent): void { }

	// setView(view: CalendarView) {
	//     this.view = view;
	// }

	/***
	 * Calender Set
	 */

	calendarOptions: CalendarOptions = {
		headerToolbar: {
			left: 'dayGridMonth,dayGridWeek,dayGridDay',
			center: 'title',
			right: 'prevYear,prev,next,nextYear',
		},
		initialView: 'dayGridMonth',
		themeSystem: 'bootstrap',
		// initialEvents: calendarEvents,
		weekends: true,
		editable: true,
		selectable: true,
		selectMirror: true,
		dayMaxEvents: true,
	};
	currentEvents: EventApi[] = [];
	/**
	 * Event add modal
	 */
	openModal(event?: any) {
		this.newEventDate = event;
		this.modalService.open(this.modalShow, { centered: true });
	}

	/**
	 * Event click modal show
	 */
	handleEventClick(clickInfo: EventClickArg) {
		this.editEvent = clickInfo.event;

		var stDate = new Date(clickInfo.event.startStr);
		stDate.setMinutes(stDate.getMinutes() - stDate.getTimezoneOffset());
		var startD = stDate.toISOString().slice(0, 16);

		if (clickInfo.event.endStr == '') {
			var endD = this.getEndTime(stDate);
		} else {
			var endDate = new Date(clickInfo.event.endStr);
			endDate.setMinutes(endDate.getMinutes() - endDate.getTimezoneOffset());
			var endD = endDate.toISOString().slice(0, 16);
		}

		this.formEditData = this.formBuilder.group({
			editTitle: clickInfo.event.title,
			startDate: clickInfo.event.start,
			endDate: endD,
			editCategory: clickInfo.event.classNames[0],
		});

		this.appointmentForm = this.fb.group({
			appointmentTime: startD,
			endAppointmentTime: endD,
			titleEvent: clickInfo.event.title,
		});

		this.modalService.open(this.editmodalShow, { centered: true });
	}

	/**
	 * Events bind in calander
	 * @param events events
	 */
	handleEvents(events: EventApi[]) {
		this.currentEvents = events;
	}

	/**
	 * Close event modal
	 */
	closeEventModal() {
		this.formData = this.formBuilder.group({
			title: '',
			category: '',
		});

		this.appointmentForm = this.fb.group({
			appointmentTime: '',
			endAppointmentTime: '',
			titleEvent: '',
		});

		this.modalService.dismissAll();
	}

	/***
	 * Model Position Set
	 */
	position() {
		Swal.fire({
			position: 'center',
			icon: 'success',
			title: 'Event has been saved',
			showConfirmButton: false,
			timer: 1000,
		});
	}

	/***
	 * Model Edit Position Set
	 */
	Editposition() {
		Swal.fire({
			position: 'center',
			icon: 'success',
			title: 'Event has been Updated',
			showConfirmButton: false,
			timer: 1000,
		});
	}

	/**
	 * Event Data Get
	 */
	get form() {
		return this.formData.controls;
	}

	/**
	 * Save the event
	 */
	saveEvent() {
		if (this.formData.valid) {
			const title = this.formData.get('title')!.value;
			const className = this.formData.get('category')!.value;
			const calendarApi = this.newEventDate.view.calendar;
			calendarApi.addEvent({
				id: createEventId(),
				title,
				start: this.newEventDate.date,
				end: this.newEventDate.date,
				className: className + ' ' + 'text-white',
			});
			this.position();
			this.formData = this.formBuilder.group({
				title: '',
				category: '',
			});
			this.modalService.dismissAll();
		}
		this.submitted = true;
	}

	/**
	 * save edit event data
	 */
	editEventSave() {
		const editTitle = this.formEditData.get('editTitle')!.value;
		const editCategory = this.formEditData.get('editCategory')!.value;

		const editId = this.calendarEvents.findIndex((x) => x.id + '' === this.editEvent.id + '');

		this.editEvent.setProp('title', editTitle);
		this.editEvent.setProp('classNames', editCategory);

		this.calendarEvents[editId] = {
			...this.editEvent,
			title: editTitle,
			id: this.editEvent.id,
			classNames: editCategory,
		};
		this.Editposition();
		this.formEditData = this.formBuilder.group({
			editTitle: '',
			editCategory: '',
		});
		this.modalService.dismissAll();
	}

	/**
	 * Delete-confirm
	 */
	confirm() {
		Swal.fire({
			title: 'Are you sure?',
			text: "You won't be able to revert this!",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#34c38f',
			cancelButtonColor: '#f46a6a',
			confirmButtonText: 'Yes, delete it!',
		}).then((result) => {
			if (result.value) {
				this.deleteEventData();
				Swal.fire('Deleted!', 'Event has been deleted.', 'success');
			}
		});
	}

	/**
	 * Delete event
	 */
	deleteEventData() {
		this.editEvent.remove();
		this.modalService.dismissAll();
	}

	scheduleMeeting() {
		let appointmentTime = new Date(this.appointmentForm.value.appointmentTime);
		let endAppointmentTime = new Date(this.appointmentForm.value.endAppointmentTime);
		// Convert the date to the desired format with a custom offset (e.g., -07:00)

		const eventDetails = {
			startTime: new Date(this.appointmentForm.value.appointmentTime),
			endTime: new Date(this.appointmentForm.value.endAppointmentTime),
			titleEvent: this.appointmentForm.value.titleEvent,
		};
		//this.generateICSFile()
		createGoogleEvent(eventDetails);
	}

	donloadICS() {
		this.calendarData = ['data:text/calendar;charset=utf8,', 'BEGIN:VCALENDAR', 'VERSION:2.0', 'BEGIN:VEVENT', 'DESCRIPTION:' + this.appointmentForm.value.titleEvent, 'DTSTART:' + this.appointmentForm.value.appointmentTime, 'DTEND:' + this.appointmentForm.value.endAppointmentTime, 'LOCATION: You can find this information in the lead information.', 'SUMMARY: This meeting has been generated through LMS Leads', 'TRANSP:TRANSPARENT', 'END:VEVENT', 'END:VCALENDAR', 'PRODID:website-1.0'].join('\n');

		window.open(this.calendarData);
	}

	getEndTime(appointmentTime: Date) {
		// Add one hour to the date
		// appointmentTime.setHours(appointmentTime.getHours() + 1);
		// const endTime = appointmentTime.toISOString().slice(0, 18) + '-07:00';
		appointmentTime.setHours(appointmentTime.getHours() + 1);
		var endTime = appointmentTime.toISOString().slice(0, 16);

		return endTime;
	}

	saveRichText() {
		if (this.selectedFieldToEdit !== 'email_template') {
			this.formCampaignInfo.get(this.selectedFieldToEdit).setValue(this.textoEnriquecido);
			this.campaignInfo[this.selectedFieldToEdit] = this.textoEnriquecido;
			this.bioData[this.selectedFieldToEdit] = this.sanitizer.bypassSecurityTrustHtml(this.textoEnriquecido);
		} else {
			this.formCampaignInfo.get(this.selectedFieldToEdit).setValue(this.textoEnriquecido);
			this.campaignInfo[this.selectedFieldToEdit] = this.textoEnriquecido;
			this.bioData[this.selectedFieldToEdit] = this.sanitizer.bypassSecurityTrustHtml(this.textoEnriquecido);
			this.email_template.body = this.textoEnriquecido;
		}
		this.modalService.dismissAll();
	}

	openTextEditor(field) {
		this.selectedFieldToEdit = field;
		this.textoEnriquecido = this.campaignInfo[this.selectedFieldToEdit];
		this.modalService.open(this.textEditorModal, { centered: true, size: 'xl' });
	}

	getFormControlValue(field) {
		this.formCampaignInfo.get(field).value();
	}

	getEditField(field) {
		switch (field) {
			case 'script':
				return 'Script';
			case 'who_we_are':
				return 'Who we are?';
			case 'what_we_do':
				return 'What we do?';
			case 'why_us':
				return 'Why Us?';
			case 'email_template':
				return 'Email Template';
		}
	}

	addWorkedHours(content) {
		this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {
			this.campaignSrv.addWorkedHours(this.addedHours, new Date().getTime(), this.campaignId, dayjs().format('YYYY-MM-DD')).subscribe((data) => {
				this.getHourlyCampaignInfo();
			});
		});
	}

	onAliasChange(){

		const user_id = this.formBasicInfo.get('user_id').value;
		const selectedUser = this.usersSelect.find(user => user.id == user_id);
		if (selectedUser) {
			this.formBasicInfo.get('alias').setValue(selectedUser.alias);
		}
		this.contractSrv.getUserContractsForCampaignWizard(user_id).subscribe((contracts: any) => {
			this.allcontracts = contracts.body;
		});
	}
}
